"use client";

import React from "react";
import { Clock, MapPin, Mail, Globe, PhoneCall } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PremiumLogisticsHub() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const badges = ["1 OF 5 STEPS"];
  const infoList = [{
    icon: MapPin,
    label: "Accident Location",
    value: "City, County, or State of Incident"
  }, {
    icon: Clock,
    label: "Accident Date",
    value: "Select the date of the occurrence"
  }, {
    icon: Mail,
    label: "Support Contact",
    value: "support@crashreportfinder.org"
  }, {
    icon: Globe,
    label: "Legal Document",
    value: "Terms of Use",
    isLink: true,
    url: "/HomePage"
  }];
  const contacts = [{
    name: "Add Your Case ID",
    phone: "Optional Field",
    role: "Faster Lookup"
  }, {
    name: "Add Your VIN Number",
    phone: "Optional Field",
    role: "Precise Matching"
  }];
  return;
}